import React from 'react';
import './SunsetTag.css';

/**
 * The SUNSET tag (Almanac S3, Decision 6; D4): the one place gold appears.
 * Whether a row carries it is `sunsetTagFor` in `utils/sunsetTag.ts`; this is
 * only the mark.
 */
export const SunsetTag: React.FC = () => <span className="sunset-tag">SUNSET</span>;

export default SunsetTag;
